<i18n>
{
  "en": {
    "userActive": "The user is active",
    "userNoActive": "The user is not active",
    "edit": "Edit user",
    "sendEmail": "Resend email",
    "delete": "Delete user",
    "regeneratePassword": "Regenerate password for this user"
  },
  "es": {
    "userActive": "El usuario esta activo",
    "userNoActive": "El usuario no esta activo",
    "edit":  "Editar usuario",
    "sendEmail": "Reenviar email",
    "delete":  "Eliminar usuario",
    "regeneratePassword":  "Regenerar contraseña para este usuario"
  }
}
</i18n>
<template>
  <dynameat-row
    :title="user.username"
    :description="`${user.firstName} - ${user.email}`"
    :button-config-list="buttonConfigList"
    :collapse-items="!$vuetify.breakpoint.mdAndUp"
    @editUserRole="onEditUserRole"
    @deleteUserRole="onDeleteUserRole"
    @regeneratePassUserRole="onRegeneratePassUserRole"
    :isClickable="false"
  >
    <template v-slot:rowIconsLeft>
      <v-tooltip class="pr-3" top v-if="user.isActive"><template v-slot:activator="{ on, attrs }">
        <v-icon class="pr-3" v-bind="attrs" v-on="on" color="green" >mdi-check-circle</v-icon></template><span>{{$t('userActive')}}</span></v-tooltip>
      <v-tooltip top v-else><template v-slot:activator="{ on, attrs }">
        <v-icon class="pr-3" v-bind="attrs" v-on="on" color="grey">mdi-check-circle</v-icon></template><span>{{$t('userNoActive')}}</span></v-tooltip>
    </template>
    <template v-slot:aboveContent>
      <v-row align="center" class="chip-top">
        <v-chip color="primary" class="chip" small>{{ userRoleMap[userRole.role] }}</v-chip>
        <v-chip v-for="pointOfSale in userPosList" :key="pointOfSale.guid" class="chip" x-small>{{ pointOfSale.name }}</v-chip>
      </v-row>
    </template>
  </dynameat-row>
</template>
<script>
import DynameatRow from '@dynameat/components/DynameatRow';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import { UserRole } from '@userManager/models';
import Vue from 'vue';

@Component
@Components({ DynameatRow })
@MapGetters(['pointOfSaleList'])
export default class UserRow extends Vue {
  @Prop({
    Object,
    validator(userRole) {
      return userRole instanceof UserRole;
    }
  }) userRole;

  get user() {
    return this.userRole.user;
  }

  get buttonConfigList() {
    return [
      {
        title: this.$t('regeneratePassword'),
        icon: 'mdi-lock-reset',
        emitName: 'regeneratePassUserRole',
      },
      {
        title: this.$t('edit'),
        icon: 'mdi-pencil',
        emitName: 'editUserRole',
      },
      {
        title: this.$t('delete'),
        icon: 'mdi-delete',
        emitName: 'deleteUserRole',
      }
    ];
  }

  get userRoleMap() {
    return {
      1: 'Manager',
      2: 'Employee'
    };
  }

  get userPosList() {
    return this.pointOfSaleList.filter((item) => this.userRole.allowedPointsOfSales.includes(item.guid));
  }

  onEditUserRole() {
    this.$emit('edit');
  }

  onDeleteUserRole() {
    this.$emit('delete');
  }

  onRegeneratePassUserRole() {
    this.$emit('regeneratePassword');
  }
}
</script>
<style>
.v-list-item__subtitle {
  white-space: normal;
}
</style>
<style scoped lang="scss">
.chip-top {
  margin-top: 0;
  margin-left: 0;
}

.chip {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
